var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.775,
    height: 12,
    viewBox: "0 0 10.775 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2473",
    "data-name": "Group 2473",
    transform: "translate(389.161 -5040)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2423",
    "data-name": "Group 2423",
    transform: "translate(-1416.697 4894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2421",
    "data-name": "Group 2421",
    transform: "translate(1031.729 146) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2416",
    "data-name": "Group 2416",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2415",
    "data-name": "Group 2415",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M4.857,2.015A.132.132,0,0,0,4.84,2L2.933.049a.154.154,0,0,0-.267.1V1.177H.195C.1,1.177,0,1.2,0,1.28V2.92a.236.236,0,0,0,.195.205H2.666v.923a.164.164,0,0,0,.092.144H2.82a.164.164,0,0,0,.113-.051L4.84,2.2A.133.133,0,0,0,4.857,2.015Z",
    fill: "#339"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M5.565,11.531A.471.471,0,0,1,5.091,12H1.9A1.888,1.888,0,0,1,0,10.125V1.875A1.888,1.888,0,0,1,1.9,0h5.83a1.888,1.888,0,0,1,1.9,1.875V5.156a.474.474,0,0,1-.948,0V1.875A.944.944,0,0,0,7.726.938H1.9a.944.944,0,0,0-.948.938v8.25a.944.944,0,0,0,.948.938H5.091A.471.471,0,0,1,5.565,11.531ZM7.252,2.813H2.368a.469.469,0,1,0,0,.938H7.252a.469.469,0,1,0,0-.937Zm.474,2.344a.472.472,0,0,0-.474-.469H2.368a.469.469,0,1,0,0,.938H7.252A.472.472,0,0,0,7.726,5.156ZM2.368,6.563a.469.469,0,1,0,0,.938H4.86a.469.469,0,1,0,0-.937Z",
    transform: "translate(1038.312 158) rotate(180)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportTemplate);
export default __webpack_public_path__ + "static/media/import_template.7cdf1deecc57e9dc5c96b5b82ef4bc0d.svg";
export { ForwardRef as ReactComponent };